import axios from "axios"; // Import axios
import React, { useState } from "react";
import whatsapp from "../../src/images/homepage/form/whatsapp.png";
import Loading from '../loading'

const ContactDetilas = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    message: "",
  });
  const [loading, setLoading] = useState(false); 

  // Function to handle changes in the input fields
  const handleChange = (e) => {
    const { name, value } = e.target;

    // If the input is for the contact number, only allow numbers
    if (name === "contactNumber") {
      // Allow only numbers using regex
      const numericValue = value.replace(/[^0-9]/g, ""); // Regex to remove non-numeric characters
      setFormData({ ...formData, [name]: numericValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if any field is empty
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.contactNumber.trim() ||
      !formData.message.trim()
    ) {
      alert("Please fill out all fields before submitting.");
      return;
    }

    setLoading(true);

    // Send the email to Gmail using axios
    try {
      const response = await axios.post(
        `${API_URL}/api/messages/send-email`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        alert("Message sent successfully!");
        // Clear the form
        setFormData({
          name: "",
          email: "",
          contactNumber: "",
          message: "",
        });
      } else {
        alert("Failed to send message");
      }
    } catch (error) {
      console.error(error);
      alert("Error sending message");
    } finally {
      setLoading(false); // Stop loading after the try/catch
    }
  };

  const handleWhatsApp = async (e) => {
    e.preventDefault();

    // Validation: Check if any field is empty
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.contactNumber.trim() ||
      !formData.message.trim()
    ) {
      alert("Please fill out all fields before submitting.");
      return;
    }

    setLoading(true);

    // Send the form data to WhatsApp using axios
    try {
      const response = await axios.post(
        `${API_URL}/api/messages/send-whatsapp-form`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        alert("Message sent to WhatsApp!");
        // Clear the form
        setFormData({
          name: "",
          email: "",
          contactNumber: "",
          message: "",
        });
      } else {
        alert("Failed to send message to WhatsApp");
      }
    } catch (error) {
      console.error(error);
      alert("Error sending message");
    } finally {
      setLoading(false); // Stop loading after the try/catch
    }
  };

  return (
    <section className="flex flex-col gap-5 items-center justify-center bg-banner w-full h-auto pb-40 px-4">
      <div className="flex flex-col items-start justify-start gap-5 w-full max-w-4xl">
        <div className="flex flex-col lg:flex-row gap-4 w-full">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            className="border border-[#F0FFC5] rounded-xl px-4 py-3 text-[#F0FFC5] bg-[#212121] placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full lg:w-[50%]"
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className="border border-[#F0FFC5] rounded-xl px-4 text-[#F0FFC5] py-3 bg-[#212121] placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full lg:w-[50%]"
          />
        </div>

        <div className="w-full">
          <input
            type="text"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            placeholder="Contact Number"
            className="border border-[#F0FFC5] rounded-xl text-[#F0FFC5] px-4 py-3 bg-[#212121] placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
          />
        </div>

        <div className="w-full">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Write your message ...."
            className="border border-[#F0FFC5] rounded-xl text-[#F0FFC5] px-4 py-3 bg-[#212121] placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
            rows={4}
          />
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-4 mt-4 w-full max-w-4xl justify-center items-center">
      {loading ? (
      <div>
        <Loading />
      </div>
        ) : (
        <>
        <button
          onClick={handleSubmit}
          className="text-[#F0FFC5] text-md font-semibold py-4 px-12 bg-[#060C0A] rounded-full shadow-inner-custom 
             transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-b hover:from-[#060C0A] hover:to-[#4c5b207c] active:scale-95 active:translate-y-1"
          disabled={loading}     
        >     
        Send Message
        </button>

        <button
          onClick={handleWhatsApp}
          className="bg-[#0B7300] text-white font-semibold rounded-full py-4 px-12 hover:bg-[#0B7300] transition-colors flex items-center justify-center w-[200px]"
          disabled={loading}
        >
          <img src={whatsapp} alt="WhatsApp" className="w-5 h-5 mr-2" />
          WhatsApp
        </button>
        </>
          )}
      </div>
    </section>
  );
};

export default ContactDetilas;
